<template>
    <el-container class="mill-index">
        <el-main>
            <el-header class="column-header">
                <span>矿机收益计算</span>
                <!-- <el-radio-group v-model="chartType" size="mini" @change="chartTypeEvent">
                    <el-radio-button label="币"></el-radio-button>
                    <el-radio-button label="人民币"></el-radio-button>
                </el-radio-group> -->
            </el-header>
            <div class="mill-chart-filter">
                
            </div>

            <div class="mill-chart-contain">
                <!-- 汇总信息显示 -->
                <div class="mill-chart-info">
                    <div class="mill-chart-info__item">
                        <el-form :inline="true" size="mini" :model="millParam" label-width="100px">
                            <el-form-item label="电费单价">
                                <el-input placeholder="电费单价" v-model="millParam.p"></el-input>
                                <span>元/度</span>
                            </el-form-item>
                            <el-form-item label="日挖矿量变化率">
                                <el-input placeholder="日挖矿量变化率" v-model="millParam.n"></el-input>
                                <span>%</span>
                            </el-form-item>
                            <el-form-item label="日币价变化率">
                                <el-input placeholder="日币价变化率" v-model="millParam.l"></el-input>
                                <span>%</span>
                            </el-form-item>
                        </el-form>
                        <el-form :inline="true" size="mini" :model="millParam" label-width="100px">
                            <el-form-item label="模拟天数">
                                <el-input placeholder="模拟天数" v-model="millParam.d"></el-input>
                                <span>天</span>
                            </el-form-item>
                            <el-form-item label="起始日期">
                                <el-date-picker
                                v-model="millParam.date"
                                align="right"
                                type="date"
                                placeholder="选择日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="mill-chart-info__item">
                        <div>
                            <label>投资机型：</label>
                            <!-- <el-select size="mini" v-model="grapCardP">
                                <el-option label="机型3070 8卡" value="0.479"></el-option>
                            </el-select> -->
                            <el-input class="mill-chart-info__grap" size="mini" v-model="grapCardName" placeholder="机型价格"></el-input>
                            <el-input size="mini" v-model="grapCardPrice" placeholder="机型价格" @input="calculateP"></el-input> CNY
                            <span> 
                                <el-input size="mini" v-model="grapCardP" placeholder="算力/台" @input="calculateP"></el-input> T
                                <el-input size="mini" v-model="grapCardPw" @input="calculateP"></el-input> KW
                            </span>
                        </div>
                        <div class="mill-chart-info__count">
                            <label>投资台数：</label>
                            <el-input size="mini" v-model="grapCount" @input="calculateP"></el-input>
                            台 
                            <span>{{grapCost}}</span>CNY
                            <span>
                                <span>{{millParam.g}}</span>G
                            </span>
                            <span>
                                <span>{{p}}</span>KW
                            </span>
                            <el-button class="btn__style" size="mini" @click="getMillData">计 算</el-button>
                        </div>
                    </div>
                    <div class="mill-chart-info__item">
                        <table>
                            <tbody>
                                <tr>
                                    <td>日产币：</td>
                                    <td>{{calculateFee(1, 4)['coin']}}</td>
                                    <td>BTC ≈</td>
                                    <td><span>{{calculateFee()['cny']}}</span> CNY</td>
                                    <td>{{this.millParam.g}} T</td>
                                    <td>电费 <span>{{handleNAN(calculateFee()['dFee'])}}</span> CNY</td>
                                    <td>占比 {{calculateFee()['rate']}}%</td>
                                </tr>
                                <tr>
                                    <td>周产币：</td>
                                    <td>{{calculateFee(7, 4)['coin']}}</td>
                                    <td>BTC ≈</td>
                                    <td><span>{{calculateFee(7)['cny']}}</span> CNY</td>
                                    <td>{{this.millParam.g}} T</td>
                                    <td>电费 <span>{{calculateFee(7)['dFee']}}</span> CNY</td>
                                    <td>占比 {{calculateFee()['rate']}}%</td>
                                </tr>
                                <tr>
                                    <td>月产币：</td>
                                    <td>{{calculateFee(30, 4)['coin']}}</td>
                                    <td>BTC ≈</td>
                                    <td><span>{{calculateFee(30)['cny']}}</span> CNY</td>
                                    <td>{{this.millParam.g}} T</td>
                                    <td>电费 <span>{{calculateFee(30)['dFee']}}</span> CNY</td>
                                    <td>占比 {{calculateFee()['rate']}}%</td>
                                </tr>
                                <tr>
                                    <td>180D产币：</td>
                                    <td>{{calculateFee(180, 4)['coin']}}</td>
                                    <td>BTC ≈</td>
                                    <td><span>{{calculateFee(180)['cny']}}</span> CNY</td>
                                    <td>{{this.millParam.g}} T</td>
                                    <td>电费 <span>{{calculateFee(180)['dFee']}}</span> CNY</td>
                                    <td>占比 {{calculateFee()['rate']}}%</td>
                                </tr>
                                <tr>
                                    <td>360D产币：</td>
                                    <td>{{calculateFee(360, 4)['coin']}}</td>
                                    <td>BTC ≈</td>
                                    <td><span>{{calculateFee(360)['cny']}}</span> CNY</td>
                                    <td>{{this.millParam.g}} T</td>
                                    <td>电费 <span>{{calculateFee(360)['dFee']}}</span> CNY</td>
                                    <td>占比 {{calculateFee()['rate']}}%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="mill-chart-info__item">
                        <div class="mill_top">
                            <div>
                                <label for="">回本周期</label>
                                <span><strong>{{otherData.period}}</strong>天</span>
                                <span>{{otherData.period_date}}</span>
                            </div>
                            <p>
                                总产币 <strong style="color: #1AB394;">{{handleNAN(otherData[totalColumn1.key])}}
                                    </strong> BTC≈<strong>{{handleCny(otherData['total_earnings'])}}</strong> 
                                <span>电费: <strong>{{handleNAN(otherData.total_pow)}}</strong>CNY/占比 {{handleNAN(otherData.pow_rate*100)}}%</span>
                            </p>
                        </div>
                        <div class="mill_bottom">
                             <div>
                                <label for="">利润周期</label>
                                <span><strong>{{handleNAN(otherData.period1)}}</strong>天</span>
                                <span>{{otherData.period_date1}}</span>
                            </div>
                            <p>
                                总产币 <strong style="color: #1AB394;">{{handleNAN(otherData[totalColumn2.key])}}</strong>
                                 BTC≈<strong>{{handleCny(otherData['total_earnings1'])}}</strong> 
                                <span>电费: <strong>{{handleNAN(otherData.total_pow1)}}</strong>CNY/占比 {{handleNAN(otherData.pow_rate*100)}}%</span>
                            </p>
                            
                        </div>
                        <div class="mill_bottom">
                            <p style="border-top: 1px solid #43474f;">累计挖币 <strong class="coin">{{getTotalCoin['coin']}}</strong> <span>按今日价格可卖<strong>{{getTotalCoin['total']}}</strong></span></p>
                        </div>
                    </div>
                </div>
                <div class="mill-chart-contain__right">
                    <div class="mill-chart-box" ref="millChart"></div>
                </div>
            </div>


            <!-- <div class="mill-table-top">
                <div v-if="chartType == '币'">
                    <span>截止日期: {{handleNAN(otherData.last_date)}}</span>
                    <span>回本日期: {{handleNAN(otherData.period_date_coin)}}</span>
                    <span>回本周期(天): {{handleNAN(otherData.period_coin)}}</span>
                    <span>累计挖矿收入: {{handleNAN(otherData.last_profit_coin)}}</span>
                    <span>回本后收入: {{handleNAN(otherData.last_income_coin)}}</span>
                    <span>矿机残值: {{handleNAN(otherData.salvage)}}</span>
                </div>
                <div v-else>
                    <span>截止日期: {{handleNAN(otherData.last_date)}}</span>
                    <span>回本日期: {{handleNAN(otherData.period_date)}}</span>
                    <span>回本周期(天): {{handleNAN(otherData.period)}}</span>
                    <span>累计挖矿收入: {{handleNAN(otherData.last_profit)}}</span>
                    <span>回本后收入: {{handleNAN(otherData.last_income)}}</span>
                    <span>矿机残值: {{handleNAN(otherData.salvage)}}</span>
                </div>
            </div> -->

            <div class="collapse-header">
                <span v-for="(title, index) in tableColumn" :key="'title_'+index">{{title.title}}</span>
            </div>
            <el-collapse>
                <el-collapse-item v-for="(datas, index) in tableData" :key="'table_'+index">
                    <template slot="title">
                        <div v-for="(header, index) in tableColumn" :key="'header_'+index">
                            {{typeof getLastDay(datas)[header.key] == 'number'?getCnyData(header.key, getLastDay(datas))+getCnyDataP(header.key, getLastDay(datas)): getLastDay(datas)[header.key]+'/'+getMonthNum(getLastDay(datas)[header.key])}}
                        </div>
                    </template>
                    <div v-for="(mon, index) in datas" :key="'mon_'+index" class="">
                        <span v-for="(header, index) in tableColumn" :key="'cheader_'+index">
                            {{typeof mon[header.key] == 'number'?getCnyData(header.key, mon):mon[header.key]}}
                            {{getCnyDataP(header.key, mon)}}
                        </span>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </el-main>
    </el-container>
</template>

<script>
// import { postMillData } from '@/api/api.js';
import $ from 'jquery';
// import { types } from 'util';

export default {
    data: function () {
        return {
            millParam: {
                token: '142536',
                x: 5000,  // grapCardPrice 机型价格
                w: 2,   // grapCardPw 机型功耗
                g: 42,  // grapCardP 机型算力
                p: 0.35,  // 电费单价
                n: -0.05,  // 日挖矿量变化率
                l: 0,  // 日币价变化率
                date: "2020-02-24", // 开始日期
                d: 360 // 模拟天数
            },
            millData: [],
            otherData: {},
            formData: [],
            tableTitle: [
                {title: '日期', key: 'time'},
                {title: '日成本(未包含残值)', key: 'cost_day'},
                {title: '残值现金流', key: 'sur_value'},
                {title: '每日成本', key: 'cost_day_sur'},
            ],
            chartType: '币',
            tableData: {},
            grapCardP: '104', // 机型算力
            grapCardPrice: 40000, // 机型价格
            p: '', // 功率/kw
            grapCount: 100,   // 投资台数
            grapCost: 0,
            incomeObj: {},
            grapCardPw: 3.068,  // 机型功耗
            grapCardName: 'S19j'

        }
    },
    mounted() {
        this.millParam.date = new Date().format('yyyy-MM-dd');
        this.getMillData();
        this.calculateP();
    },
    computed: {
        tableColumn() {// 表格头部
            if (this.chartType == '币') {
                return [
                    {title: '日期', key: 'time'},
                    {title: '矿池每T收益', key: 'earnings_1G_coin'},
                    {title: '币价/元', key: 'cny'},
                    // {title: '价格/美元', key: 'usd'},
                    {title: '每日产币', key: 'earnings_coin'},
                    {title: '日产币卖出累计', key: 'total_earnings_coin'},
                    {title: '每日电费/CNY', key: 'pow_cost_coin'},
                    {title: '累计电费/CNY', key: 'total_pow_coin'},
                    // {title: '日净收入(币)', key: 'net_profit_coin'},
                    {title: '净收益CNY', key: 'total_profit_coin'},
                ];
            } else {
                return [
                    {title: '日期', key: 'time'},
                    {title: '价格/元', key: 'cny'},
                    // {title: '价格/美元', key: 'usd'},
                    {title: '日收益', key: 'earnings'},
                    {title: '日电费', key: 'pow_cost'},
                    {title: '日收益/G', key: 'earnings_1G'},
                    {title: '日净收入', key: 'net_profit'},
                    {title: '累计电费', key: 'total_pow'},
                    {title: '累计净收入(已交电费)', key: 'total_profit'},
                    {title: '累计收益', key: 'total_earnings'},
                ];
            }
        },

        totalColumn() {// 汇总信息显示
            if (this.chartType == '币') {
                return [
                    {title: '截止日期：', key: 'last_date'},
                    {title: '回本周期(单位:天)：', key: 'period_coin'},
                    {title: '回本日期：', key: 'period_date_coin'},
                    {title: '初始成本：', key: 'ini_cost_coin'},
                    {title: '累计挖矿收入：', key: 'last_earnings_coin'},
                    {title: '累计电费：', key: 'last_pow_coin'},
                    {title: '累计收入(交电费后)：', key: 'last_profit_coin'},
                    {title: '回本后收入：', key: 'last_income_coin'},
                    {title: '预测矿机残值：', key: 'salvage_coin'},
                ]
            } else {
                return [
                    {title: '截止日期：', key: 'last_date'},
                    {title: '回本周期(单位:天)：', key: 'period'},
                    {title: '回本日期：', key: 'period_date'},
                    {title: '初始成本：', key: 'ini_cost'},
                    {title: '累计挖矿收入：', key: 'last_earnings'},
                    {title: '累计电费：', key: 'last_pow'},
                    {title: '累计收入(交电费后)：', key: 'last_profit'},
                    {title: '回本后收入：', key: 'last_income'},
                    {title: '预测矿机残值：', key: 'salvage'},
                ]
            }
        },
        totalColumn1() {// 汇总信息显示1
            if (this.chartType == '币') {
                return {title: '总收入: ', key: 'total_earnings_coin'};
                
            } else {
                return {title: '总收入: ', key: 'total_earnings'};
            }
        },
        totalColumn2() {// 汇总信息显示2
            if (this.chartType == '币') {
                return {title: '总收入: ', key: 'total_earnings_coin1'};
                
            } else {
                return {title: '总收入: ', key: 'total_earnings1'};
            }
        },
        getTotalCoin() {
            let total_earnings_coin1;
            this.otherData.total_earnings_coin1 ? total_earnings_coin1 = this.otherData.total_earnings_coin1: total_earnings_coin1=0;
            return {
                coin: this.handleNAN((total_earnings_coin1+this.otherData.total_earnings_coin)),
                total: this.handleNAN((total_earnings_coin1+this.otherData.total_earnings_coin)*this.otherData.cprice),
            };
        },
        
    },
    methods: {
        getMillData(flag) {// 数据获取
            var that = this;
            this.millParam.x = this.grapCardPrice;
            this.millParam.w = this.grapCardPw;
            this.millParam.g = this.grapCardP;
            this.millParam.t = this.grapCount;
            this.millParam.ccy = 'BTC';

            $.ajax({
                url: this.$URL_KJ+'/predict2',
                type: 'post',
                data: this.millParam,
                success: function (res) {
                    let rut = JSON.parse(res);
                    if (rut.code == 200) {
                        that.millData = rut.data.datas;
                        that.otherData = rut.data;
                        that.chartTypeEvent();
                        that.calculateP();
                        that.sortData();

                        if (flag) {
                            that.$notify.info({
                                title: '提示',
                                message: '提交成功！',
                                offset: 100
                            })
                        }
                    } else {
                        that.$notify.info({
                            title: '提示',
                            message: rut.msg,
                            offset: 100
                        });
                    }
                }
            })
        },

        initChart() {// 初始化阶梯图
            let myChart = this.$echarts.init(this.$refs.millChart);
            let chartData = this.handleData();
            let that = this;
            let option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "line"
                    },
                    textStyle: {
                        align: 'left'
                    },
                    backgroundColor: '#19224D',
                    padding: 15,
                    formatter: function (data) {
                        let index_data = data[0];
                        let otherUnit;
                        if (that.chartType == '币') {
                            otherUnit = '￥';
                        } else {
                            otherUnit = '币';
                        }

                        let title_pro = `日电费：`;
                        let title_day = `日收益（${that.chartType}）：`;

                        
                        let mark_html = index_data.axisValue+'<br>'+
                        data[1].marker+title_pro+data[1].value+ '<br>'+
                        index_data.marker+title_day + index_data.data+'<br>'+
                        `价格（元）：` + chartData.y2[index_data.dataIndex]+'<br>'+
                        `日收益（${otherUnit}）：` + chartData.y3[index_data.dataIndex]+'<br>';
                        return mark_html;
                    }
                },
                title: {
                    text: '每/T 收益图',
                    textStyle: {
                        color: '#7B818E'
                    },
                    // textAlign: 'right'
                    left: '5%'
                },
                grid: {
                    // left: '0'
                },
                legend: {
                    data: [
                        { name: '日收益', icon: 'rect' },
                        { name: '日电费', icon: 'rect' },
                    ],
                    textStyle: {
                        color: "#999"
                    }
                },
                color: ['#db5634', '#1AB394'],
                backgroundColor: '#1e2429',
                xAxis: {
                    type: "category",
                    data: chartData.x,
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        color: '#7B818E',
                    },
                },
                yAxis: [{
                    name: '日收益',
                    color: '#7B818E',
                    nameTextStyle: {
                        color: '#7B818E'
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#383E56",
                            width: 1
                        },
                    },
                    axisLine: {
                        show: true
                    },
                    axisLabel: {
                        color: '#7B818E',
                    }
                }, {
                    name: '日电费',
                    color: '#7B818E',
                    position: 'right',
                    nameTextStyle: {
                        color: '#7B818E'
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#383E56",
                            width: 1
                        },
                    },
                    axisLine: {
                        show: true
                    },
                    axisLabel: {
                        color: '#7B818E',
                    }
                }],
                series: [
                    {
                        name: '日收益',
                        data: chartData.y,
                        type: "line",
                        step: "start",
                        yAxisIndex: 0,
                        showAllSymbol: false,
                        symbol: 'circle',
                        symbolSize: 1,
                    },
                    {
                        name: '日电费',
                        data: chartData.y1,
                        type: "line",
                        step: "start",
                        yAxisIndex: 0,
                        showAllSymbol: false,
                        symbol: 'circle',
                        symbolSize: 1,
                    }
                ]
            };

            myChart.setOption(option);
        },

        handleData() {// 数据处理
            let x_arr = [];
            let y_arr = [];
            let y_arr1 = [];
            let y_cny = [];
            let y_usd = [];

            for (var i=0; i<this.millData.length; i++) {
                let i_data = this.millData[i];
                let x_data = i_data.time.split('T')[0];
                let y_data, y_data2, y_data3, y_data4;

                if (this.chartType == '币') {
                    y_data = i_data.earnings_coin;
                    y_data2 = i_data.pow_cost_coin;
                    y_data3 = i_data.cny;
                    y_data4 = i_data.earnings;
                } else {
                    y_data = i_data.earnings;
                    y_data2 = i_data.pow_cost;
                    y_data3 = i_data.cny;
                    y_data4 = i_data.earnings_coin;
                }
                x_arr.push(x_data);
                y_arr.push(y_data.toFixed(4));
                y_arr1.push(y_data2.toFixed(4));
                y_cny.push(y_data3.toFixed(2));
                y_usd.push(y_data4.toFixed(2));
            }
            return {
                x: x_arr,
                y: y_arr,
                y1: y_arr1,
                y2: y_cny,
                y3: y_usd
            };
        },

        sortData() {// 数据分类
            var sort_data = {};
            for (let i=0; i<this.millData.length; i++) {
                let i_data = this.millData[i];
                if (!i_data.total_pow_coin) {
                    continue;
                }
                let time = i_data.time.split('-')[0]+'-'+i_data.time.split('-')[1];
                if (!sort_data.hasOwnProperty(time)) {
                    sort_data[time] = [];
                    sort_data[time].push(i_data);
                } else {
                    sort_data[time].push(i_data);
                }
            }
            this.tableData = sort_data;
        },

        getLastDay(data) {// 获取每个月最后一天数据
            return data[data.length-1];
        },

        submitForm() {// 提交表单
            this.getMillData('submit');
        },

        chartTypeEvent() {// 表格模式选择
            this.initChart();
        },

        handleNAN(data, d=2) {// 补充空值，保留2未小数
            if (typeof data == 'string') {
                return data ? data : '--';
            }
            return data ? data.toFixed(d) : '--';
        },

        calculateP() {// 计算公式
            // 总算力计算公式 = 机器算力*台数
            this.millParam.g = this.handleNAN(this.grapCardP * this.grapCount);
            this.grapCost = this.handleNAN(this.grapCount*this.grapCardPrice); // 机器成本=价格*台数
            this.p = this.handleNAN(this.grapCardPw*this.grapCount);
        },

        calculateP1() {
            this.grapCount = Math.round(this.millParam.g/this.grapCardP);
            this.grapCost = this.handleNAN(this.grapCount*this.grapCardPrice);
            // this.grapCardPrice = this.handleNAN(this.millParam.x*this.grapCardP);
        },

        calculateFee(t=1, d=2) {
            let dFreeDay = this.handleNAN(this.p*this.millParam.p*24*t, d); // 每t天电费
            let incomeCoin = this.handleNAN(this.millParam.g*this.otherData.income*t, d); // 每t天收益/币
            let incomeCNY = this.handleNAN(incomeCoin*this.otherData.price-dFreeDay, d); // 每t天收益/元
            let rate = this.handleNAN(dFreeDay/incomeCNY*100);

            return {
                coin: incomeCoin,
                cny: incomeCNY,
                rate: rate,
                dFee: dFreeDay,
            }
        },

        handleCny(data) {
            if (this.chartType == '币') {
                if (data) {
                    return this.handleNAN(data)+'CNY';
                }
                return this.handleNAN(data);
            }
            return this.handleNAN(data);
        },

        getMonthNum(date) {
            return this.tableData[date.slice(0, 7)].length;
        },

        getCnyData(key, data) {
            if (key == 'pow_cost_coin') {
                return '';
            }
            if (key == 'total_profit_coin') {
                return '';
            }
            if (key == 'earnings_1G_coin') {
                return data[key].toFixed(8);
            }
            if (key == 'cny') {
                return data[key].toFixed(2);
            }
            return data[key].toFixed(4);
        },
        getCnyDataP(key, data) {
            let keys = key.replace('_coin', '');
            if (key == 'earnings_coin') {
                return ''
            } 
            if (key == 'pow_cost_coin' || key == 'total_profit_coin') {
                if (key.indexOf('_coin') !== -1) {
                    return data[keys].toFixed(2);
                }  
            }
            if (key.indexOf('_coin') !== -1) {
                return '≈'+data[keys].toFixed(2);
            } 
            return '';
        } 
    }
}
</script>

<style lang="scss">
.mill-index {
    .mill-chart-box {
        width: 1000px;
        height: 586px;
        padding: 10px;
        background-color: #1e2429;
    }
    .mill-table-top {
        text-align: left;
        color: #999;
        padding: 10px;
    }
    .mill-table-top span {
        padding: 5px 20px;
        display: inline-block;
        color: #db5634;
        font-weight: 600;
        font-size: 16px;
    }
    .el-input__inner {
        background-color: #333333;
        border: 1px solid #333333;
    }
    .mill-chart-filter {
        background-color: #2a2d2e;
        padding: 10px 0;
    }
    .el-popper[x-placement^=bottom] .popper__arrow::after {
            border-bottom-color: transparent;
    }
    .el-header {
        padding: 0 10px;
        .el-radio-group{
            margin-left: 20px;
        }
    }
    .el-main {
        .mill-chart-contain {
            background-color: #2a2d2e;
            padding-bottom: 20px;
        }
        .mill-chart-contain>div{
            display: inline-block;
            vertical-align: top;
            margin: 0 10px;
        }
        .mill-chart-info>div{
            min-height: 50px;
            // border: 1px solid #34373e;
            text-align: left;
            padding: 10px;
        }
        .mill-chart-info {
            min-width: 400px;
            width: 740px;
            border-radius: 5px;
            opacity: 0.7;
            color: #7B818E;
            
            .el-input {
                width: 100px;
            }
            .el-select {
                margin-right: 5px;
                .el-input {
                    width: 140px;
                }
            }
            .mill-chart-info__item>div {
                margin: 5px 0;
                position: relative;
                button {
                    position: absolute;
                    right: -5px;
                    top: -35px;
                    padding: 8px 30px;
                    height: 67px;
                }
            }
            .mill-chart-info__item{
                margin-bottom: 10px;
                background-color: #192027;
                span {
                    padding: 0 5px;
                }
                .mill-chart-info__grap {
                    margin-right: 10px;
                }
                table {
                    width: 100%;
                    td{
                        padding: 5px;
                    }
                    td:nth-child(1) {
                        text-align: right;
                    }
                    td:nth-child(2) {
                        text-align: right;
                        font-size: 14px;
                        font-weight: 600;
                        color: #1AB394;
                    }

                    td:nth-child(4) {
                        span {
                            width: 90px;
                            text-align: right;
                            color: #db5634;
                            display: inline-block;
                            font-weight: 600;
                            font-size: 14px;
                        }
                    }
                    td:nth-child(6) {
                        span {
                            width: 90px;
                            text-align: right;
                            display: inline-block;
                        }
                    }
                }

                .mill_top, .mill_bottom {
                    font-size: 14px;
                    p, div {
                        padding: 5px 0;
                    }
                    p {
                        text-align: center;
                    }
                    div {
                        text-align: center;
                    }

                    strong {
                        font-size: 18px;
                        color: #db5634;
                        padding: 0 5px;
                    }
                    strong.coin {
                        color: #1AB394;
                    }
                }
                .mill_top {
                    padding: 10px 0;
                    border-bottom: 1px solid #4e525d;
                }
                    
            }

            li {
                text-align: left;
                padding: 5px 0;
                label, span {
                    color: #7B818E;
                    font-size: 15px;
                    // display: inline-block;
                }
            }
            li>label {
                width: 130px;
                color: #7B818E;
                font-size: 14px;
                // text-align: right;
            }
            li>span {
                margin-left: 5px;
                color: #409eff;
            }
        }
        .el-form {
            .el-form-item__label {
                font-size: 12px;
            }
            .el-form-item__content {
                width: 130px;
                .el-input {
                    width: 80px;
                }
                .el-date-editor {
                    width: 100%;
                }
                span{
                    color: #7B818E;
                    font-size: 12px;
                    margin-left: 3px;
                }
            }
            .el-form-item {
                margin-bottom: 5px;
            }
        }
        .collapse-header {
            background-color: #2a2d2e;
            margin-top: 10px;
            span {
                width: 12.5%;
                display: inline-block;
                vertical-align: middle;
                text-align: right;
                color: #999;
                padding: 5px 0;
            }
        }
        .el-collapse {
            border-color: #1e1e1e;
        }
        .el-collapse-item__header {
            background-color: #2A2D2E;
            border-bottom: 1px solid #1e1e1e;
            color: #7B818E;
        }
        .el-collapse-item__header>div{
            width: 12.5%;
            text-align: right;
        }
        .el-collapse-item__wrap {
            border-color: #1e1e1e;
        }
        .el-collapse-item__content>div>span{
            display: inline-block;
            vertical-align: middle;
            width: 12.5%;
            text-align: right;
            color: #7B818E;
            box-sizing: border-box;
            padding-right: 5px;
        }
        .el-collapse-item__content{
            background-color: #252829;
        }
        .el-collapse-item__content>div{
            border-bottom: 1px solid #383737;
        }
    }

    .el-table {
        background-color: #2a2d2e;
        font-size: 12px;
        // margin-top: 10px;
        .el-table__header-wrapper {
            background-color: transparent;
        }
        tr th.is-leaf, td {
            background-color: transparent;
            border-bottom: 1px solid #5a595a;
            padding: 8px 0;
        }

        tr th.is-leaf {
            background-color: #2a2d2e;
        }
        th, tr {
            background-color: transparent;
        }
    }
    .el-table--border::after, .el-table--group::after, .el-table::before {
        content: '';
        position: absolute;
        background-color: transparent;
        z-index: 1;
    }
    .el-table--striped .el-table__body tr.el-table__row--striped td{
        background: #2a2d2e;
    }
    .el-table--enable-row-hover .el-table__body tr:hover>td{
        background-color: #2a2d2e;
    }
    tbody {
        tr:hover {
            background-color: #2a2d2e;
            td {
                color: #999999;
                background-color: transparent;
            }
        }
    }

    // tr:nth-child(even) {
    //     background-color: #262829;
    // }
    // tr:nth-child(odd) {
    //     background-color: #2e3538;
    // }

    .el-radio-button__inner {
        background-color: #c5c1c1;
    }
}
</style>